import styled from "styled-components";
import { ArrowRightIcon, TrashIcon } from "@heroicons/react/24/outline";
import { Action, Button } from "@sablier/v2-components/molecules";
import { tags } from "@sablier/v2-constants";
import { useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";
import { useFormPrepare } from "../logic";

const WrapperPartial = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    width: 100%;
    padding: calc(${(props) => props.theme.sizes.edge} * 1)
      ${(props) => props.theme.sizes.modalEdge};
    border-top: 2px solid ${(props) => props.theme.colors.border};
  }
`;

const Actions = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    column-gap: calc(${(props) => props.theme.sizes.edge} * 1 / 2);
  }
`;

const Wrapper = styled(WrapperPartial)`
  ${(props) => props.theme.medias.maxMD} {
    padding: calc(${(props) => props.theme.sizes.edge} * 1)
      calc(${(props) => props.theme.sizes.edge} * 3 / 2);
  }
  ${(props) => props.theme.medias.maxSM} {
    padding: calc(${(props) => props.theme.sizes.edge} * 3 / 4);
    *[data-component="action"] {
      & > *:first-child {
        display: none;
      }
      & > *:last-child {
        width: 100%;
      }
    }
    ${Actions} {
      width: 100%;
      & > * {
        flex: 1;
      }
    }
  }
`;

function Footer() {
  const { estimated, onConfirm, onClear } = useFormPrepare();
  const { t } = useT();

  return (
    <Wrapper>
      <Action
        description={t("modalCards.duration.footer.description", { estimated })}
        title={t("modalCards.duration.footer.title")}
      >
        <Actions>
          <Button
            accent={"gray400"}
            appearance={"transparent"}
            onClick={onClear}
            right={TrashIcon}
            title={t("words.clear")}
          />
          <Button
            accent={"iconic400"}
            appearance={"outline"}
            onClick={onConfirm}
            right={ArrowRightIcon}
            title={t("modalCards.duration.confirm")}
            titleShort={t("words.confirm")}
            cy={tags.actionDurationPicker}
          />
        </Actions>
      </Action>
    </Wrapper>
  );
}

export default Footer;
